/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;
export enum UiMediaDeviceKind {
	AUDIO_INPUT, AUDIO_OUTPUT, VIDEO_INPUT
}